module.exports = __webpack_public_path__ + "img/20200321104806QQ截图20190624162006.dade2aa0.png";